import React, { useEffect, useState } from "react"
import { Input, message, Modal, Space, Tooltip } from "antd"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import PopupAction from "src/components/PopupAction"
import IconBase from "src/components/IconBase"
import WarehouseService from "src/services/WarehouseService"
import dayjs from "dayjs"
import OrderService from "src/services/OrderService"
import { reject } from "lodash"
import { data } from "jquery"
import ModalCreateOrder from "../../Modal/ModalCreateOrder"
const _dataSource = []

function ListOrder({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
}) {
  const [dataSource, setDataSource] = useState(_dataSource)
  const [dataSelected, setDataSelected] = useState([])
  const [isModalAction, setIsModalAction] = useState({})
  const [openModalDetail, setOpenModalDetail] = useState(false)
  const [openModalEdit, setOpenModalEdit] = useState(false)
  const [editingRecord, setEditingRecord] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [rejectReason, setRejectReason] = useState("")
  const [rejectModalVisible, setRejectModalVisible] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)

    try {
      const res = await WarehouseService.listOrder({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        const formatted = res?.success?.data.map((item, index) => ({
          ...item,
          key: item.ID || index,
          approved_person: item.approvedby?.fullname || "",
          total_amount: Number(item.total_amount).toLocaleString("en-US"),
          total_discount: Number(item.total_discount).toLocaleString("en-US"),
        }))
        const users = res?.success?.data || []
        const total = res?.success?.total || users.length
        const current = res.success?.current_page
        const perPage = res.success?.per_page

        setDataSource(formatted)
        setPagination({
          ...pagination,
          total: total,
        })
        setSummary({
          totalAccounts: total,
        })
        // setDataSource(
        //  ...res.success.data,
        //   // approved_by: res.success.data.approvedby.fullname,
        // )
      }
    } catch (err) {
      console.error("Lỗi gọi listOrder:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)

    setParentFilter(filter)
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  // useEffect(() => {
  //   setPagination({
  //     ...pagination,
  //     current: 1,
  //   })
  // }, [filter])
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setDataSelected(selectedRows)
    },
  }

  const handleAction = (type, record) => {
    setIsModalAction({ type, record })

    if (type === "view") {
      setOpenModalDetail(true)
      setEditingRecord(record)
    }
    if (type === "edit") {
      setOpenModalEdit(true)
      setEditingRecord(record)
    }
    if (type === "approve") {
      approveProposal(record)
    }
    if (type === "reject") {
      setRejectModalVisible(true)
      setSelectedRecord(record)
    }
  }
  const ActionItem = ({ icon, label, onClick }) => (
    <div
      onClick={e => {
        e.stopPropagation()
        onClick()
      }}
      className="action-item"
    >
      <IconBase name={icon} />
      <span>{label}</span>
    </div>
  )

  const approveProposal = async record => {
    setLoading(true)

    try {
      const res = await OrderService.approveOrder(record.ID)
      if (
        res.message ===
        "Duy\u1ec7t \u0110\u01a1n h\u00e0ng th\u00e0nh c\u00f4ng."
      ) {
        message.success(res.message)
        setRefresh(prev => !prev)
      } else {
        message.error("Không thể duyệt đơn")
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "Lỗi không xác định từ máy chủ"
      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }
  const rejectProposal = async selectedRecord => {
    if (!rejectReason.trim())
      return message.warning("Vui lòng nhập lý do từ chối")

    setLoading(true)
    try {
      const res = await OrderService.rejectOrder(selectedRecord.ID, {
        note: rejectReason,
      })
      if (res.message === "Hủy Đơn hàng  thành công.") {
        // Nếu phản hồi có message thành công
        console.log(rejectReason, "rejectReason")
        message.success("Đã từ chối thành công")
        setRejectModalVisible(false)
        setRejectReason("")
        setRefresh(prev => !prev)
      } else {
        // Nếu không có message thành công, hiển thị thông báo lỗi
        message.error("Không thể từ chối đơn")
      }
    } catch (err) {
      message.error("Lỗi khi từ chối: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const column = [
    {
      title: "Mã đơn hàng",
      dataIndex: "export_code",
      align: "center",
    },
    {
      title: "Tên khách hàng",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    // {
    //   title: "Loại SIM",
    //   dataIndex: "sim_quantity",
    //   key: "sim_quantity",
    // },
    {
      title: "Số lượng SIM",
      dataIndex: "sim_quantity",
      key: "sim_quantity",
      align: "center",
    },

    // {
    //   title: "Đơn giá SIM",
    //   dataIndex: "sim_unit_price",
    //   key: "sim_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Dung lượng Data",
      dataIndex: "data_quantity",
      key: "data_quantity",
      align: "center",
    },
    // {
    //   title: "Đơn giá data",
    //   dataIndex: "data_unit_price",
    //   key: "data_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Tổng tiền",
      dataIndex: "total_amount",
      key: "total_amount",
    },
    {
      title: "Tổng tiền sau chiết khấu",
      dataIndex: "total_discount",
      key: "total_discount",
    },
    {
      title: "Người tạo",
      dataIndex: "createby",
      key: "createby",
      render: createby => createby?.fullname || "",
      align: "center",
    },
    {
      title: "Ngày tạo",
      dataIndex: "created_at",
      key: "created_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
    {
      title: "Người duyệt",
      dataIndex: "approved_person",
      key: "approved_person",
      align: "center",
    },
    //   {
    //     title: "Ngày duyệt",
    //     dataIndex: "approved_at",
    //     key: "approved_at",
    //   },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: text => {
        switch (text) {
          case "0":
            return (
              <span style={{ color: "orange", fontWeight: "bold" }}>
                Chờ duyệt
              </span>
            )
          case "1":
            return (
              <span style={{ color: "green", fontWeight: "bold" }}>
                Đã duyệt
              </span>
            )
          case "2":
            return (
              <span style={{ color: "red", fontWeight: "bold" }}>Từ chối</span>
            )
          default:
            return "Không xác định"
        }
      },
    },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const isPending = record.status === "0"
        return (
          //order.delete
          <PopupAction>
            {permissions.includes("order.detail") ? (
              <ActionItem
                icon="eye"
                label="Xem chi tiết"
                onClick={() => handleAction("view", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("order.browse") && isPending ? (
              <ActionItem
                icon="approval"
                label="Duyệt"
                onClick={() => handleAction("approve", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("order.refuse") && isPending ? (
              <ActionItem
                icon="cancelApproval"
                label="Từ chối"
                onClick={() => handleAction("reject", record)}
              />
            ) : (
              <React.Fragment />
            )}
          </PopupAction>
        )
      },
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        {!!dataSelected.length && (
          <ButtonCircle
            style={{ marginRight: "10px", marginBottom: "10px" }}
            title="Xóa hàng đã chọn"
            iconName="delete-outline"
            onClick={() =>
              CB1({
                title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
                icon: "trashRed",
                okText: "Đồng ý",
                onOk: async close => {
                  // Logic to delete selected rows
                  close()
                },
              })
            }
          />
        )}
        {/* <FilterOrder
          setFilter={setFilter}
          setKeyword={setKeyword}
          // tabStatus={tabStatus}
        /> */}
      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={column}
        dataSource={dataSource}
        showPagination
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {openModalDetail && (
        <ModalCreateOrder
          open={openModalDetail}
          onCancel={() => setOpenModalDetail(false)}
          onOk={() => {
            setOpenModalDetail(false)
          }}
          // data={dataSource.find(item => item.index === isModalAction.customerId)}
          editingRecord={editingRecord}
          isEditMode={true}
          refresh={setRefresh}
          onlyView={true}
        />
      )}
      {openModalEdit && (
        <ModalCreateOrder
          open={openModalEdit}
          onCancel={() => setOpenModalEdit(false)}
          onOk={() => {
            setOpenModalEdit(false)
          }}
          // data={dataSource.find(item => item.index === isModalAction.customerId)}
          editingRecord={editingRecord}
          isEditMode={true}
          refresh={setRefresh}
        />
      )}
      {rejectModalVisible && (
        <Modal
          title="Nhập lý do từ chối"
          open={rejectModalVisible}
          onOk={() => rejectProposal(selectedRecord)}
          onCancel={() => {
            setRejectModalVisible(false)
            setRejectReason("")
            setSelectedRecord(null)
          }}
          okText="Xác nhận từ chối"
          cancelText="Hủy"
          confirmLoading={loading}
        >
          <Input.TextArea
            rows={4}
            placeholder="Nhập lý do từ chối..."
            value={rejectReason}
            onChange={e => setRejectReason(e.target.value)}
          />
        </Modal>
      )}
    </div>
  )
}

export default ListOrder
